import React, { useState } from 'react';
import Loading from '../components/Loading';
import SessionManager from "../routes/SessionManager";
import CommonUtils from '../util/CommonUtils';

// format: https://login-sandbox.procore.com/oauth/authorize?response_type=code&client_id=0209c3a4ed0b4d60cc6e493a7fce0529a4baefcae974dab6adea9e83312e26c6&redirect_uri=https://www.sitesupt.com:8443/settings?cp={{procore.company.id}}-{{procore.project.id}}
// Prod : https://login.procore.com/oauth/authorize?response_type=code&client_id=3e1ca11c1bea250d7b79c5f3ff6c759b8b606643b1a95460e102267354310e2a&redirect_uri=https://www.sitesupt.com/settings?cp={{procore.company.id}}-{{procore.project.id}}
// https: https://login.procore.com/oauth/authorize?client_id=3e1ca11c1bea250d7b79c5f3ff6c759b8b606643b1a95460e102267354310e2a&response_type=code&redirect_uri=https://www.sitesupt.com/settings?site_id=7777963129656
// Sandbox : https://login-sandbox.procore.com/oauth/authorize?response_type=code&client_id=0209c3a4ed0b4d60cc6e493a7fce0529a4baefcae974dab6adea9e83312e26c6&redirect_uri=https://www.sitesupt.com:8443/settings?cp=13986-8779

function SSO() {

    let searchParams = new URL(window.location).searchParams;
    let capture = searchParams.get('captureCode');
    let code = searchParams.get('code');
    let company_proj = searchParams.get('cp');
    if (capture || window.opener) {
        window.opener.window.location = 'https://www.sitesupt.com/settings?code=' + code + '&cp=' + company_proj;
        return window.close();
    }
    if (company_proj && code) {
        let cp_parts = company_proj.split('-');
        setTimeout(function () {
            initProcoreAccountCheck({ company_id: cp_parts[0], code: code, project_id: cp_parts[1] });
        }, 2000);
    } else if (code) {
        window.location = window.location.href.replace('settings', 'site-management');
    } else {
        window.location = "/";
    }

    const [loading, setLoading] = useState(true);

    const initProcoreAccountCheck = (obj) => {
        CommonUtils.ajax(
            {
                url: window.location.origin + '/procore/authorize-procore-user',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(obj)
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200) {
                        let data = res.data;
                        let sessionManager = new SessionManager();
                        sessionManager.storeCookie('sso', data);
                    }
                }
                window.location = '/';
                setLoading(false);
            },
            (res) => {
                window.location = '/';
                setTimeout(function () {
                    setLoading(false);
                }, 1000)
            })
    }

    return (
        <React.Fragment>
            {loading && <div className="p-2"><Loading>Loading ....</Loading></div>}
        </React.Fragment>
    );
}

export default SSO;